import { toast } from "react-toastify"

import { useLazyCreateMessageTemplateOldQuery, useLazyGetMessageTemplatesOldQuery } from "store/api/contractorsApi"
import { ApiTypes, UITypes } from "types"

import getErrorMessage from "utils/getErrorMessage"
import { MessageForm } from "components/form/MessageFormOld"

import MessageTemplateContainer from "../MessageTemplateContainerOld/MessageTemplateContainer"

export const MessageTemplateCreate = () => {
  const [triggerCreateMessageTemplate] = useLazyCreateMessageTemplateOldQuery()
  const [triggerGetMessageTemplates] = useLazyGetMessageTemplatesOldQuery()

  const onCreateTemplate = async (data: UITypes.MessageTemplate) => {
    try {
      const res = await triggerCreateMessageTemplate({
        title: data.title,
        body: data.message,
        body_rich: data.message_rich || "",
        repeat_every: data.frequency as ApiTypes.Model.MessageTemplateFrequency,
      })
      const error = getErrorMessage(res?.error)

      if (error) {
        toast.error(error)
      } else {
        toast.success("Message template has been successfully created!")
        triggerGetMessageTemplates()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <MessageTemplateContainer title="Create message template">
      <MessageForm onSave={onCreateTemplate} />
    </MessageTemplateContainer>
  )
}
